import { type FC, type ReactNode, type MouseEvent, type CSSProperties } from 'react'
import { type ZIndex } from 'shared/constants/zIndex'
import { type IRightModalProps } from 'shared/ui/Modal/ui/RightModal/RightModal'
import { type IButtonProps } from 'shared/ui'

export enum ModalTypeList {
  DEFAULT = 'default',
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  ALERT = 'alert',
  FAIL = 'fail',
  CLOCK = 'clock',
}

export type IModal<T extends object = object> = ModalType<T> | IRightModalProps['modal']

export type ModalType<T extends object = object> = {
  id: string
  isStopPropagation?: boolean
  store?: unknown
  type?: ModalTypeList
  position?: 'right'
  onClose?: () => void
  title?: ReactNode
  titleDividerContent?: ReactNode
  subtitle?: ReactNode
  desc?: ReactNode
  width?: CSSProperties['width']
  primaryAction?: {
    text: string
    onAction: (e?: MouseEvent<HTMLButtonElement>) => void | Promise<void>
    disabled?: boolean
    fullWidth?: boolean
  }
  secondaryAction?: {
    text: string
    onAction: (e?: MouseEvent<HTMLButtonElement>) => void | Promise<void>
    disabled?: boolean
  }
  closeActionButtonProps?: IButtonProps
  additionalSecondaryAction?: {
    text: string
    onAction: (e?: MouseEvent<HTMLButtonElement>) => void | Promise<void>
    disabled?: boolean
  }
  infoModalTextAction?: string
  showHeader?: boolean
  closeText?: string
  showCloseButton?: boolean
  showCloseIcon?: boolean
  ModalError?: FC<T>
  ModalAlert?: FC<T>
  ModalBottomError?: FC<T>
  ModalActions?: FC<T>
  ModalContent?: FC<T>
  ModalContentProps?: T
  paddingContent?: string | number
  paddingTopModal?: string | number
  pureContent?: boolean
  disabledOnAllClose?: boolean
  disabledOverlayClose?: boolean
  disabledOnEscClose?: boolean
  center?: boolean
  zIndex?: ZIndex
  fullHeight?: boolean
  autoOverflow?: boolean
  ariaLabel?: string
  hiddenContent?: boolean
  className?: string
  customTitle?: ReactNode
}
